/**
 * VoxPop Review app created by karora on 11/03/17.
 */
import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {ProfileService} from "./services/profile.service";
import {UserProfile} from "./types/user-profile";

type AuthState = 'checking' | 'signedOut' | 'sessionExpired' | 'accessDenied' | 'profileError' | 'ready';

@Component({
    selector: 'voxpop-review',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})

export class AppComponent implements OnInit {
  private static title = 'VoxPop Review';
  public menuState: string = 'out';
  public authState: AuthState = 'checking';
  private routerEventsBound = false;

  constructor(
    private router: Router,
    private profileService: ProfileService,
  ) {}

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) {
      this.setAuthState('signedOut');
      return;
    }

    this.setAuthState('checking');
    try {
      this.profileService.GetProfile().subscribe({
        next: profile => {
          if (!profile || !profile.id) {
            this.setAuthState('profileError');
            return;
          }

          AppComponent.SetUser(profile);
          if (ProfileService.CanReview() || ProfileService.CanAdminister()) {
            this.setAuthState('ready');
            this.bindRouterEvents();
            return;
          }

          this.setAuthState('accessDenied');
        },
        error: err => {
          console.log(err);
          if (err && err.status === 401) {
            this.setAuthState('sessionExpired');
            return;
          }

          this.setAuthState('profileError');
        },
      });
    } catch (e) {
      console.log(e);
      this.setAuthState('profileError');
    }
  }

  public static SetTitle(newTitle: string):void  {
    AppComponent.title = newTitle;
    let title = document.getElementById("title");
    if (title) {
      title.innerText = newTitle;
    }
  }

  public static SetUser(profile: UserProfile): void {
    let userShite = document.getElementById("username");
    if (userShite && profile && profile.social.name) {
      try {
        // userShite.getElementsByTagName("a")[0].innerText = profile.social.name;
      } catch(e) {
        userShite.innerText = profile.social.name;
      }
    }
  }

  public static zpad(v:any, n: number):string {
    let s: string = '000000000000' + v;
    return s.substring(s.length - n);
  }

  private bindRouterEvents(): void {
    if (this.routerEventsBound) {
      return;
    }

    this.routerEventsBound = true;
    this.router.events.subscribe(() => {
      this.hideMenu();
    });
  }

  private setAuthState(authState: AuthState): void {
    this.authState = authState;
  }

  retrySession(): void {
    window.location.reload();
  }

  toggleMenu(): void {
    this.menuState = this.menuState === 'out' ? 'in' : 'out';
  }

  hideMenu(): void {
    this.menuState = 'out';
  }
}
